// ✅ P2-2: Layout constants to replace magic numbers

/**
 * Sidebar layout dimension constants
 * Used for calculating feature list heights dynamically
 */
export const SIDEBAR_LAYOUT = {
  /** Combined height of header and category header (px) */
  HEADER_HEIGHT: 120,
  /** Height of individual category header when expanded (px) */
  CATEGORY_HEADER_HEIGHT: 40,
  /** Height of category when collapsed (px) */
  COLLAPSED_CATEGORY_HEIGHT: 40,
  /** Minimum height for feature list to ensure readability (px) */
  MIN_FEATURE_LIST_HEIGHT: 200,
  /** Height of the license button at the bottom of sidebar (px) */
  LICENSE_BUTTON_HEIGHT: 50,
} as const;

/**
 * Timing constants for debounce and throttle operations
 * Used to optimize performance and prevent race conditions
 */
export const TIMING = {
  /** Debounce delay for URL synchronization to prevent rapid state updates (ms) */
  URL_SYNC_DEBOUNCE: 150,
  /** Throttle interval for resize event handlers (ms) */
  RESIZE_THROTTLE: 200,
} as const;

/**
 * Mobile interaction constants
 * Used for touch gesture recognition
 */
export const SWIPE = {
  /** Minimum horizontal swipe distance to trigger sidebar close (px) */
  CLOSE_THRESHOLD: 50,
} as const;
